// eslint-disable-next-line no-use-before-define
import React from 'react';
import { useTranslation } from 'react-i18next';
export const AssistanceItem = ({ title, description, buttonLabel, status, hint, successLabel, danger, onClick, }) => {
    const { t } = useTranslation('drawerAssistance');
    const isRunning = status === 'running';
    return (React.createElement("div", { className: `drawer-assistance_item ${danger ? 'danger' : ''}` },
        React.createElement("div", { className: "drawer-assistance_item-info" },
            React.createElement("p", { className: "drawer-assistance_item-title" }, title),
            React.createElement("p", { className: "drawer-assistance_item-description" }, description),
            hint && React.createElement("p", { className: "drawer-assistance_item-hint" }, hint),
            status === 'success' && (React.createElement("p", { className: "drawer-assistance_item-feedback success" }, successLabel ?? t('drawerAssistance:feedbackSuccess'))),
            status === 'error' && (React.createElement("p", { className: "drawer-assistance_item-feedback error" }, t('drawerAssistance:feedbackError')))),
        React.createElement("button", { disabled: isRunning, onClick: onClick }, isRunning ? t('drawerAssistance:btnRunning') : buttonLabel)));
};
//# sourceMappingURL=assistance-item.js.map